import { useState } from "react";

export default function CancelOrderModal({ open, onClose, onConfirm }) {
  const [reason, setReason] = useState("");

  if (!open) return null;

  return (
    <>
   
    <div className="fixed inset-0 z-[70] flex items-center justify-center montserrat-font-1 bg-black/40">
      <div className="bg-white w-[350px] rounded-xl shadow-lg p-6">
        
        <h2 className="text-lg font-semibold text-gray-800 mb-4">
          Select Cancellation Reason
        </h2>

        <div className="flex flex-col gap-3 mb-6">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              value="restaurant"
              checked={reason === "restaurant"}
              onChange={(e) => setReason(e.target.value)}
              className="accent-red-500"
            />
            <span className="text-sm">Cancelled by Restaurant</span>
          </label>

          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              value="customer"
              checked={reason === "customer"}
              onChange={(e) => setReason(e.target.value)}
              className="accent-red-500"
            />
            <span className="text-sm">Cancelled by Customer</span>
          </label>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded-lg text-sm"
          >
            Close
          </button>

          <button
            onClick={() => onConfirm(reason)}
            disabled={!reason}
            className={`px-4 py-2 rounded-lg text-sm text-white ${
              reason
                ? "bg-red-500 hover:bg-red-600"
                : "bg-red-300 cursor-not-allowed"
            }`}
          >
            Confirm Cancel
          </button>
        </div>
      </div>
    </div>
    </>
  );
}